import { DEFAULT_STATION } from '../../types'
import { TrashIcon, XIcon } from '../icons'
import '../pos/ConfirmDialog.css'
import './StationDialog.css'

export interface StationUse {
  name: string
  /** Bu tezgahı kullanan kategoriler. */
  categoryNames: string[]
  /** Fişi bu tezgaha düşen ürünler. */
  products: number
  /** Açık ürün penceresinde seçildi, henüz kaydedilmedi. */
  unsaved?: boolean
  /** Fişi basılmıyor (yalnız mutfak ekranı). */
  noPrint: boolean
}

/**
 * Tezgahları düzenle (25 Eki 2026). Tezgahların ayrı bir listesi yok: bir
 * tezgah, kategorilere ve ürünlere yazılan adlardan oluşuyor. Silinince o
 * tezgahın kategorileri varsayılan tezgaha (Mutfak) geçiyor, ona özel
 * ürünler kategorilerinin tezgahına dönüyor. Mutfak silinmiyor.
 */
export function StationsDialog({
  stations,
  onDelete,
  onClose,
}: {
  stations: StationUse[]
  onDelete: (name: string) => void
  onClose: () => void
}) {
  return (
    <div className="dlg" role="dialog" aria-modal="true" aria-label="Tezgahlar">
      <div className="dlg__card dlg__card--ask dlg__card--x stdlg">
        <button type="button" className="dlg__x" onClick={onClose} aria-label="Kapat">
          <XIcon />
        </button>
        <h2>Tezgahlar</h2>

        <ul className="stlist">
          {stations.map((s) => {
            const used = s.unsaved
              ? 'Bu ürün (kaydedilmedi)'
              : [s.categoryNames.join(', '), s.products > 0 && `${s.products} ürün`].filter(Boolean).join(', ')
            return (
              <li key={s.name} className="stlist__row">
                <div className="stlist__text">
                  <b>{s.name}</b>
                  <small>
                    {used || 'Kullanılmıyor'}
                    {s.noPrint && ', fiş basılmıyor'}
                  </small>
                </div>
                {s.name !== DEFAULT_STATION ? (
                  <button
                    type="button"
                    className="icon-btn is-danger"
                    onClick={() => onDelete(s.name)}
                    aria-label={`${s.name} tezgahını sil`}
                  >
                    <TrashIcon />
                  </button>
                ) : (
                  <span className="stlist__lock">Varsayılan</span>
                )}
              </li>
            )
          })}
        </ul>

        <p className="stdlg__note">
          Silinen tezgahın kategorileri "{DEFAULT_STATION}" tezgahına geçer, ürünler silinmez. "{DEFAULT_STATION}"
          varsayılan tezgahtır, silinemez.
        </p>

        <div className="dlg__buttons">
          <button type="button" className="btn btn--primary" onClick={onClose}>
            Tamam
          </button>
        </div>
      </div>
    </div>
  )
}
